import $ from 'jquery';
window.$ = $;
window.jQuery = $;

// Debug logs for initial state
console.log('Initial state:');
console.log('- Spree backend:', typeof Spree !== 'undefined' ? 'loaded' : 'not loaded');
console.log('- Flatpickr:', typeof flatpickr !== 'undefined' ? 'loaded' : 'not loaded');
console.log('- jQuery:', typeof jQuery !== 'undefined' ? 'loaded' : 'not loaded');

// Load Popper first and make it global
let Popper = require('../../../vendor/assets/javascripts/spree/frontend/popper.min.js');
if (Popper.default) Popper = Popper.default;
window.Popper = Popper;

// Verify Popper is global before loading Bootstrap
console.log('Popper check before Bootstrap:', typeof window.Popper);

// Now load Bootstrap and expose it globally
let bootstrap = require('../../../vendor/assets/javascripts/spree/frontend/bootstrap.min.js');
if (bootstrap.default) bootstrap = bootstrap.default;
window.bootstrap = bootstrap;

import '../../../vendor/assets/javascripts/spree/frontend/plugins.js';

import '../spree/frontend/main.js';

import "controllers"
import "@stripe/stripe-js" 

// Final state debug logs
console.log('Final application.js state:');
console.log('- jQuery:', typeof jQuery !== 'undefined' ? 'loaded' : 'not loaded');
console.log('- Popper:', typeof Popper !== 'undefined' ? 'loaded' : 'not loaded');
console.log('- Bootstrap:', typeof bootstrap !== 'undefined' ? 'loaded' : 'not loaded');
console.log('- Tab plugin:', typeof jQuery.fn.tab !== 'undefined' ? 'loaded' : 'not loaded');
console.log('- Spree backend:', typeof Spree !== 'undefined' ? 'loaded' : 'not loaded');
console.log('- Flatpickr:', typeof flatpickr !== 'undefined' ? 'loaded' : 'not loaded');